import { blockDraftAsyncLocalChanges } from './block-draft-async';
import { publishedWorkoutStatusAsyncLocalChanges } from './published-workout-status-async';
export const getLocalChanges = (args, store) => {
    switch (args.module) {
        case 'Block':
            return blockLocalChanges(args, store);
        case 'BlockDraftWorkout':
            return blockDraftWorkoutLocalChanges(args);
        case 'AthleteDraftWorkout':
            return athleteDraftWorkoutLocalChanges(args);
        case 'BlockDraftAsync':
            return blockDraftAsyncLocalChanges(args, store);
        case 'AthleteActualWorkout':
            return athleteActualWorkoutLocalChanges(args);
        case 'AthleteModifiedPublishedWorkout':
            return athleteModifiedPublishedWorkoutLocalChanges(args);
        case 'PublishedWorkoutStatus':
            return publishedWorkoutStatusAsyncLocalChanges(args, store);
        default:
            const _ = args;
            throw new Error(`Unknown module: ${args.module}`);
    }
};
function blockLocalChanges({ input, type }, store) {
    if (type === 'Create' || type === 'Copy') {
        const { focuses, ...rest } = input;
        let block = rest;
        if ('blockIdToCopy' in block) {
            // Make sure we don't pass along the blockIdToCopy
            const { blockIdToCopy: _, ...withoutCopy } = block;
            block = withoutCopy;
        }
        return [
            {
                action: 'create',
                modelName: 'Block',
                modelId: input.id,
                data: { ...block, status: 'planned' },
            },
            ...focuses.map((f) => ({
                action: 'create',
                modelName: 'BlockFocus',
                modelId: f.id,
                data: { ...f, blockId: input.id },
            })),
        ];
    }
    else if (type === 'Edit') {
        const { focuses, ...block } = input;
        // Get current block focuses to delete them
        const oldFocuses = store.getMany('BlockFocus', {
            blockId: input.id,
        });
        return [
            {
                action: 'update',
                modelName: 'Block',
                modelId: input.id,
                data: block,
            },
            // Delete old focuses
            ...oldFocuses.map((f) => ({
                action: 'delete',
                modelName: 'BlockFocus',
                modelId: f.id,
            })),
            // Create new focuses
            ...focuses.map((f) => ({
                action: 'create',
                modelName: 'BlockFocus',
                modelId: f.id,
                data: { ...f, blockId: input.id },
            })),
        ];
    }
    else if (type === 'Delete') {
        const focuses = store.getMany('BlockFocus', {
            blockId: input.id,
        });
        return [
            ...focuses.map((f) => ({
                action: 'delete',
                modelName: 'BlockFocus',
                modelId: f.id,
            })),
            {
                action: 'delete',
                modelName: 'Block',
                modelId: input.id,
            },
        ];
    }
    else if (type === 'Cancel') {
        const block = store.getOne('Block', { id: input.id });
        if (!block) {
            return [];
        }
        return [
            {
                action: 'update',
                modelName: 'Block',
                modelId: input.id,
                data: { ...block, status: 'canceled' },
            },
        ];
    }
    else {
        const _ = type;
        throw new Error(`Unknown block command type: ${type}`);
    }
}
function blockDraftWorkoutLocalChanges({ identity, edits, }) {
    return edits.map((edit) => {
        if (edit.action === 'create') {
            return {
                ...edit,
                data: {
                    ...edit.data,
                    unpublishedChangeCount: 0,
                    blockId: identity.blockId,
                    workoutId: identity.workoutId,
                    id: edit.modelId,
                    deletedAt: edit.data.deletedAt ?? null, // ensure deletedAt is null if not provided
                    // Preserve the layer from edit.data (all create actions include a layer)
                    layer: edit.data.layer,
                },
            };
        }
        else {
            return edit;
        }
    });
}
function athleteDraftWorkoutLocalChanges({ identity, edits, }) {
    return edits.map((edit) => {
        if (edit.action === 'create') {
            return {
                ...edit,
                data: {
                    ...edit.data,
                    unpublishedChangeCount: 0,
                    blockId: identity.blockId,
                    profileId: identity.profileId,
                    workoutId: identity.workoutId,
                    id: edit.modelId,
                    deletedAt: edit.data.deletedAt ?? null,
                    excludeAssignedDate: edit.data.excludeAssignedDate ?? false,
                    layer: edit.data.layer,
                },
            };
        }
        else {
            return edit;
        }
    });
}
function athleteActualWorkoutLocalChanges({ identity, edits, }) {
    // Additional layers (athletePublishedWorkoutLayer, blockPublishedWorkoutLayer, athleteModifiedPublishedWorkoutLayer)
    // are passed through for access/manipulation but don't generate local changes since they're not being saved
    return edits.map((edit) => {
        if (edit.action === 'create') {
            return {
                ...edit,
                data: {
                    ...edit.data,
                    blockId: identity.blockId,
                    profileId: identity.profileId,
                    workoutId: identity.workoutId,
                    athleteVersion: identity.athleteVersion,
                    blockVersion: identity.blockVersion,
                    id: edit.modelId,
                    // Preserve the layer from edit.data (all create actions include a layer)
                    layer: edit.data.layer,
                },
            };
        }
        else {
            return edit;
        }
    });
}
function athleteModifiedPublishedWorkoutLocalChanges({ identity, edits, }) {
    return edits.map((edit) => {
        if (edit.action === 'create') {
            return {
                ...edit,
                data: {
                    ...edit.data,
                    blockId: identity.blockId,
                    profileId: identity.profileId,
                    workoutId: identity.workoutId,
                    athleteVersion: identity.athleteVersion,
                    blockVersion: identity.blockVersion,
                    id: edit.modelId,
                    // Preserve the layer from edit.data (all create actions include a layer)
                    layer: edit.data.layer,
                },
            };
        }
        else {
            return edit;
        }
    });
}
//# sourceMappingURL=index.js.map